import React from "react";
import { withTranslation, useTranslation } from "react-i18next";
import { generatePath, useNavigate } from "react-router-dom";
import { Link } from "@mui/material";
import {
  Background,
  Container,
  LogoContainer,
  Logo,
  Title,
  SubTitle,
} from "./styles";
import ROUTES from "navigation/routes";

const OnboardingDisabledMessage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleSignIn = () => {
    navigate(generatePath(ROUTES.SIGN_IN), { replace: true });
  };

  return (
    <Background>
      <Container>
        <LogoContainer>
          <Logo alt="Logo" />
        </LogoContainer>
        <Title>{t("onboarding-disabled-message:title")}</Title>
        <SubTitle>{t("onboarding-disabled-message:message")}</SubTitle>
        <Link
          textAlign="center"
          onClick={handleSignIn}
          sx={{
            cursor: "pointer",
            display: "block",
            marginTop: "50px",
          }}
        >
          {t("web-common:sign-in.back-to-signin")}
        </Link>
      </Container>
    </Background>
  );
};

export default withTranslation()(OnboardingDisabledMessage);
